import { render, staticRenderFns } from "./AuthUser.vue?vue&type=template&id=56f7c6e6&"
import script from "./AuthUser.vue?vue&type=script&lang=js&"
export * from "./AuthUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports